import { Dispatch } from 'react';
import { UploadFile } from 'antd';
import { useIntl } from 'react-intl';
import { StyledCreateEditPagesGallery } from './style';
import { FileUploader } from '../FileUploader';

interface CreateEditPagesGalleryProps {
  onFileListChange?: Dispatch<any>;
  fileList: UploadFile[];
}

export const CreateEditPagesGallery = ({
  onFileListChange,
  fileList,
}: CreateEditPagesGalleryProps) => {
  const intl = useIntl();
  return (
    <StyledCreateEditPagesGallery>
      <FileUploader
        fileList={fileList}
        onFileListChange={onFileListChange}
        showActions={true}
        multiple={true}
        title={intl.formatMessage({ id: 'general.gallery_title' })}
        isCrop={true}
        aspectRatio={1}
        horizontal={false}
      />
    </StyledCreateEditPagesGallery>
  );
};
